import { Alert, Snackbar } from '@mui/material';
import React from 'react';

interface ReusableAlertProps {
  open: boolean;
  onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
  severity: 'error' | 'warning' | 'info' | 'success';
  text: string;
}

const ReusableAlert: React.FC<ReusableAlertProps> = ({
  open,
  onClose,
  severity,
  text,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{
          width: '100%',
          fontFamily: 'Bebas Neue',
          borderRadius: '8px',
          fontSize: '1.5rem',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {text}
      </Alert>
    </Snackbar>
  );
};

export default ReusableAlert;
